import { useCallback } from 'react';
import { useSetAtom } from 'jotai';
import SubscriptionDuplicateModal from 'src/components/AzarOnly/Subscription/SubscriptionDuplicateModal';
import { showModalAtom } from 'src/stores/modal/atoms';
import { ModalType } from 'src/types/Modal';
import { useSubscriptionStatus } from './useSubscriptionStatus';
export const useDuplicateSubscriptionModal = () => {
  const showModal = useSetAtom(showModalAtom);
  const {
    hasDuplicateSubscription
  } = useSubscriptionStatus();
  const checkAndShowDuplicateModal = useCallback(() => {
    if (hasDuplicateSubscription) {
      showModal({
        key: ModalType.SUBSCRIPTION_DUPLICATE,
        component: () => <SubscriptionDuplicateModal />
      });
    }
  }, [showModal, hasDuplicateSubscription]);
  return {
    checkAndShowDuplicateModal
  };
};